import querystring from './querystring';
import hashParams from './hash-params';
import logger from './logger';

const debugTrigger = 'advertdebug';

if (
	querystring.get(debugTrigger) !== undefined ||
	hashParams.get(debugTrigger) !== undefined ||
	window.localStorage.getItem(debugTrigger) === 'true'
) {
	load();
}

hashParams.addListener(debugTrigger, load);

export function load(): void {
	try {
		const baseUrl = getBaseUrl(),
			script = document.createElement('script');

		script.src = `${baseUrl}/advert-debug.js`;
		script.async = true;
		script.addEventListener('load', () => {
			const interval = setInterval(() => {
				if (window.advert?.debug?.start) {
					window.advert.debug.start();
					clearInterval(interval);
				}
			}, 1000);
		});

		document.head.appendChild(script);
	} catch (e) {
		logger.warn('Could not load debug script', e);
	}
}

function getBaseUrl(): string {
	if (document.currentScript) {
		const src = (document.currentScript as HTMLScriptElement).src;

		return src.slice(0, src.lastIndexOf('/'));
	}

	return 'https://advertising-cdn.dpgmedia.cloud/web-advertising/snapshot';
}
